export const STATUS_PRIORITY = {
	UNPAID: 0,
	SIGNED: 1,
	PAID: 2,
	OVERDUE: 3,
	FORECAST: 4,
};

export const BASE_VALUE = 100000;
